import { getDisplayString } from 'src/utils/getDaysBtDate';

export const documentTypes = [
  { label: 'Daily SOAP Note', value: 'DAILY_SOAP_NOTE' },
  { label: 'Discharge', value: 'DISCHARGE' },
  { label: 'Evaluation', value: 'EVALUATION' },
  { label: 'Progress Note', value: 'WEEKLY_PROGRESS_NOTE' },
  { label: 'Recertification', value: 'RECERTIFICATION' },
  { label: 'Addendum Note', value: 'ADDENDUM_NOTE' },
  { label: 'Tran. Evaluation', value: 'TRANSITIONAL_EVALUATION' },
];

export const ActionType = [
  { label: 'MD Sign. Pending', value: 'PENDING' },
  { label: 'MD Sign. Completed', value: 'COMPLETED' },
  { label: 'MD Sign. Unassigned', value: 'UNASSIGNED' },
  { label: 'MD Sign. Not Required', value: 'NOT_REQUIRED' },
];

export const documentTypesForPhysician = [
  { label: 'Evaluation', value: 'EVALUATION' },
  { label: 'Evaluation Reform', value: 'EVALUATION_REFORM' },
  { label: 'Recertification', value: 'RECERTIFICATION' },
];
export const physicianStatus = [
  { label: 'Needs Approved ', value: 'AWAITING_SIGNATURE' },
  { label: 'Upcoming', value: 'UPCOMING' },
  { label: 'Urgent', value: 'URGENT' },
  { label: 'Overdue', value: 'OVERDUE' },
];
export const DisciplineType = [
  { label: 'PT', value: 'PT' },
  { label: 'OT', value: 'OT' },
  { label: 'SLP', value: 'SLP' },
];

export const docStatusTypes = [
  { label: 'Due Today', value: 'TODAY' },
  { label: 'Overdue', value: 'OVERDUE' },
  { label: 'Upcoming Deadline', value: 'UPCOMING' },
];

// THIN-8323: csvHeaders moved to the backend (WorklistReport.DOCS_DUE), which now
// owns the column definition for the Docs Due table, its PDF and its CSV alike.
export const myDocumentCsvHeader = [
  'Patient',
  'Document Type',
  'Discipline',
  'Therapist',
  'Date of Service',
  'Status',
  'Signed Date',
];

// THIN-8323: getDocumentStatus and convertToCSV lived here. Docs Due is now
// exported by the server, which owns the Action column and writes RFC 4180 CSV
// rather than stripping commas out of patient names to dodge escaping.
// replaceCommasWithSpace survives only for myDocumentCsv below, until My
// Documents moves to the same endpoint.
function replaceCommasWithSpace(str: any) {
  return str?.replace(/,/g, ' ');
}

export const myDocumentCsv = (data: any) => {
  const csvRows = [];
  csvRows?.push(myDocumentCsvHeader?.join(','));
  data?.forEach((item: any) => {
    const row = [
      replaceCommasWithSpace(item?.patientName),
      item?.documentType,
      item?.type,
      replaceCommasWithSpace(item?.providerName),
      item?.dateOfService,
      item?.signatureStatus,
      item?.signDate,
    ];
    csvRows?.push(row?.join(','));
  });

  return csvRows?.join('\n');
};
